import { SnippetType } from '@creditsights/api-ui-web';
import { DataLoadError, Loader } from '@creditsights/styleguide-web';
import { ReactElement } from 'react';
import useFetchSnippet from '../../hooks/snippets/useFetchSnippet';
import './Disclaimer.scss';

const DISCLAIMER_SNIPPET_KEY = 'footer';

function Disclaimer(): ReactElement {
  const { data: snippet, isLoading, isRefetching, isError, refetch } = useFetchSnippet(SnippetType.BOILER_PLATE, DISCLAIMER_SNIPPET_KEY);

  if (isError) {
    return (
      <div className="disclaimer-ctx">
        <DataLoadError onRetryClick={refetch} />
      </div>
    );
  }

  return (
    <div className="disclaimer-ctx">
      {isLoading || isRefetching ? (
        <Loader position="center" />
      ) : (
        <>
          <div className="header">Disclaimer</div>
          <div className="contents" dangerouslySetInnerHTML={{ __html: snippet?.body || '' }} />
        </>
      )}
    </div>
  );
}

export default Disclaimer;
